<template>
  <div class="kft-article-quote" :class="getClassName">
    <div v-if="image" class="quote-image">
      <img :src="image" alt="" loading="lazy" />
    </div>
    <div class="quote-content">
      <div v-if="title" class="title">{{ title }}</div>
      <div v-if="quoteString" class="text">
        {{ quoteString }}
      </div>
      <div v-if="quoteAuthorString" class="author">
        — {{ quoteAuthorString }}
      </div>
      <NuxtLink v-if="buttonLabel && buttonLink" class="mt-3" :to="buttonLink">
        <Button class="w-full font-normal">
          {{ buttonLabel }}
        </Button>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    quoteString?: string
    quoteAuthorString?: string
    buttonLabel?: string
    buttonLink?: string
    image?: string
  }>(),
  {
    title: '',
    quoteString: '',
    quoteAuthorString: '',
    buttonLabel: '',
    buttonLink: '',
    image: '',
  }
)

const getClassName = computed((): string => {
  if (!props.image && !props.title && !props.buttonLabel) return 'quote'

  if (!props.image) return 'cta'

  return 'default'
})
</script>

<style lang="postcss" scoped>
.kft-article-quote {
  @apply w-full bg-white p-5 rounded-xl border-2 border-[#f9f7f5] flex flex-col md:flex-row gap-4 mb-8;

  &.cta {
    @apply md:max-w-[500px] md:mx-auto;
  }

  &.quote {
    .text,
    .author {
      @apply text-lg text-stone-900;
    }

    .author {
      @apply mt-1.5;
    }
  }
}

.quote-content {
  @apply flex flex-col;
}

.text,
.author {
  @apply text-base text-gray-900;
}

.title {
  @apply text-center mb-2.5 text-lg font-semibold text-stone-900;
}

.quote-image {
  @apply relative w-full md:w-[280px] md:min-w-[280px] md:max-w-[280px] min-h-[190px] overflow-hidden rounded-xl;
  box-shadow: 5px 4px 0 0 #eaff90;

  img {
    @apply w-full h-full rounded-xl m-0 object-cover;
  }
}
</style>
